export default "__VITE_ASSET__cleThDV7__"